/**
 * Public base URL for showcase JSON in blob storage (no trailing slash).
 * Include container + optional prefix, e.g.
 * https://asyra.blob.core.windows.net/gutstring/showcase
 */
/** Set REACT_APP_SHOWCASE_ENABLED=false to hide showcase routes and nav links. */
export const SHOWCASE_ENABLED =
  process.env.REACT_APP_SHOWCASE_ENABLED !== 'false'

export const SHOWCASE_BASE_URL = (
  process.env.REACT_APP_SHOWCASE_BASE_URL || ''
).replace(/\/$/, '')

export function showcaseIndexUrl(): string {
  if (!SHOWCASE_BASE_URL) {
    return '/showcase-data/showcase-index.json'
  }
  return `${SHOWCASE_BASE_URL}/showcase-index.json`
}

export function showcaseLayoutUrl(slug: string): string {
  if (!SHOWCASE_BASE_URL) {
    return `/showcase-data/${encodeURIComponent(slug)}/layout.json`
  }
  return `${SHOWCASE_BASE_URL}/${encodeURIComponent(slug)}/layout.json`
}
